import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=f18edb98&scoped=true&"
import script from "./RouteDetail.vue?vue&type=script&lang=js&"
export * from "./RouteDetail.vue?vue&type=script&lang=js&"
import style0 from "./RouteDetail.vue?vue&type=style&index=0&id=f18edb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18edb98",
  null
  
)

export default component.exports